/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/sbp-mir-promocode'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import SbpMirPromocode from '@routes/SbpMirPromocode';

export const Route = createFileRoute('/sbp-mir-promocode')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={SbpMirPromocode} path='/sbp-mir-promocode' />
  )
});
